import { Component, computed, ElementRef, HostListener, inject, input, signal, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Sector } from "../../../../domain/sector/sector"
import { SectorUiService } from '../../services/sector-ui.service';
import { IconComponent } from '../../../../shared/components/ui/icon/icon.component';
import { SectorState } from 'libs/domain';
import { BadgeComponent } from 'libs/shared/components/ui/badge/badge.component';


@Component({
  selector: 'sector-badge-list-card',
  imports: [IconComponent, BadgeComponent],
  templateUrl: './sector-badge-list-card.component.html',
})
export class SectorBadgeListCard {
  
  @ViewChild('chipsContainer') chipsContainer!: ElementRef;

  sectorUiService = inject(SectorUiService)
  router = inject(Router);
  route = inject(ActivatedRoute);

  sectors = input.required<Sector[]>();
  filter = input<string | undefined>();

  chipsContainerWidth = signal(0);
  
  sectorsToShow = computed( () => {
    let elementsPerLine = this.chipsContainerWidth() / 80;
    
    if(this.sectors().length >= elementsPerLine * 2){
      return [... this.sectors().slice(0, elementsPerLine * 2 - 1)];
    }
    return [...this.sectors()];
  });
  
  showEllipsis = computed( () => {
    return this.sectors().length > this.sectorsToShow().length;
  });
  
  ngAfterViewInit(){
    setTimeout(()=> {
      let width = this.chipsContainer.nativeElement.offsetWidth;
      this.chipsContainerWidth.set(width);
    })
  }
  
  @HostListener('window:resize')
  updateChipsContainerWidth(){
    let width = this.chipsContainer.nativeElement.offsetWidth;
    this.chipsContainerWidth.set(width);
  }

  getSectorBadgeVariant(sectorState: SectorState){
    switch(sectorState){
      case SectorState.DISCONNECTED:
      case SectorState.NO_IRRIG:
      case SectorState.START_IRRIG:
      case SectorState.INCIDENCE:
      case SectorState.MALFUNCTION:
      case SectorState.WAIT_WATER:
      case SectorState.LEAK:
      case SectorState.UNKNOWN:
        return 'light';
      case SectorState.IRRIG:
      case SectorState.IRRIGATION_ALLOCATION:
        return 'solid';
      default:
        return 'light';
    }
  }

  getSectorBadgeColor(sectorState: SectorState){
    switch(sectorState){
      case SectorState.DISCONNECTED:
      case SectorState.NO_IRRIG:
      case SectorState.START_IRRIG:
      case SectorState.INCIDENCE:
      case SectorState.MALFUNCTION:
      case SectorState.WAIT_WATER:
      case SectorState.LEAK:
      case SectorState.UNKNOWN:
        return 'light';
      case SectorState.IRRIG:
      case SectorState.IRRIGATION_ALLOCATION:
        return 'info';
      default:
        return 'light';
    }
  }

}
